module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAmCAYAAACsyDmTAAAABHNCSVQICAgIfAhkiAAAAQdJREFUWIXtlkEOgyAQRf/gwcT7uHSv7l16H+nBynShNjYVkKFNacLfGf1/HnGAAYqKir4rcr1ou0Fb0MIgU8GO8zSYlEJbnmZQ7ctTroA7VL8Ss7agpe0GnQizAOj3PNe3TiAC347PUqgDzFMMMtFACvxmioU6gwGACnZ0eZw95AtU4CbUU1KvF0ganLKQIFBsgRSYy0BXC6XCRAGFCgJr06fARAP5oM4UCyMCugolgREDhaCkMKs3M/3/L8uqqbPa9lkdjFldHVldrlmNH5/oB0lGcKaWwgDAPA1m34FHWZB2eXwz9YtJetCdQTGojgZS4GYbxseUu+kItQ/3vpm6qKio6Nd6AE/KCS+4KzyKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cartojourney/img33.png
// module id = SFyu
// module chunks = 1